export default __webpack_public_path__ + "static/media/ecommerce-project.bd01cf9d.jpg";